export default __webpack_public_path__ + "static/media/BHGC_Login_logo.631684a5.png";